import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-withdrawsingle',
  templateUrl: './withdrawsingle.component.html',
  styleUrls: ['./withdrawsingle.component.css']
})
export class WithdrawsingleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
